import { render } from "./InfoTabsApp.vue?vue&type=template&id=0698261e"
import script from "./InfoTabsApp.vue?vue&type=script&lang=js"
export * from "./InfoTabsApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/js/vue/apps/InfoTabsApp.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0698261e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0698261e', __exports__)) {
    api.reload('0698261e', __exports__)
  }
  
  module.hot.accept("./InfoTabsApp.vue?vue&type=template&id=0698261e", () => {
    api.rerender('0698261e', render)
  })

}


export default __exports__